<!-- <dx-load-indicator class="load-indicator" [(visible)]="isVisible"></dx-load-indicator> -->
<app-load-indicator class="load-indicator" *ngIf="isVisible"></app-load-indicator>
